import { lazy, mount, NaviRequest, redirect, route } from 'navi';
import { UserRole } from 'providers/user';
import { hasRole } from 'providers/user/user-utils';
import React from 'react';
import { isFeatureEnabled } from 'utils/feature-flags';
import Login from './pages/account/login';
import Invoice from './pages/invoice';

const hasProducerAccess = (req: NaviRequest): boolean => {
  const context = req.context;
  return isFeatureEnabled('producer') || (hasRole([UserRole.Admin], context?.user?.roles || []) && isFeatureEnabled('admin'));
};

export default mount({
  '/': redirect('/search/dashboard'),
  '/login': route({
    view: <Login />,
  }),
  '/invoice': lazy(async (req: NaviRequest) => {
    return hasProducerAccess(req)
      ? route({ view: <Invoice /> })
      : import('./pages/page-not-found/page-not-found-routes');
  }),
  '/admin': lazy(() =>
    isFeatureEnabled('admin')
      ? import('./pages/admin-v2/admin-routes')
      : import('./pages/admin/admin-routes')
  ),
  '/account': lazy(async (req: NaviRequest) => {
    return hasProducerAccess(req)
      ? import('./pages/account/account-routes-v2')
      : import('./pages/account/account-routes')
  }),
  '/animal': lazy(() => import('./pages/animal/animal-routes')),
  '/analysis': lazy(() => import('./pages/analysis/analysis-routes')),
  '/billing': lazy(() => import('./pages/billing/billing-routes')),
  '/catalogue': lazy(() => import('./pages/catalogues/catalogue-routes')),
  '/config': lazy(() => import('./pages/config/config-routes')),
  '/producer': lazy(async (req: NaviRequest) => {
    return hasProducerAccess(req)
      ? import('./pages/producer/producer-routes')
      : import('./pages/page-not-found/page-not-found-routes');
  }),
  '/uploads': lazy(async (req: NaviRequest) => {
    return hasProducerAccess(req)
      ? import('./pages/submissions-v2/submissions-routes')
      : import('./pages/submissions/submissions-routes');
  }),
  '/shopping-cart': lazy(async (req: NaviRequest) => {
    return hasProducerAccess(req)
      ? import('./pages/shopping-cart/shopping-cart-routes')
      : import('./pages/page-not-found/page-not-found-routes');
  }),
  '/rugg': lazy(() => import('./pages/rugg/rugg-routes')),
  '/report': lazy(() => import('./pages/report/report-routes')),
  '/search': lazy(() => import('./pages/search/search-routes')),
  '/searches': lazy(() => import('./pages/searches/searches-routes')),
  '/user': lazy(() => import('./pages/user/user-routes')),
  '/404': lazy(() => import('./pages/page-not-found/page-not-found-routes')),
  '/401': lazy(
    () => import('./pages/page-not-authorized/page-not-authorized-routes'),
  ),
});
